import React from 'react';
import {useSelector} from 'react-redux';
import CollaboratorItem from '../collaborator-item';
import { APP_URL } from '../../../../../../../../../../../../../../utils';

function CollaboratorDetails (props) {

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const {collaborator} = props;

	return (
		<div className="collaborators-list">
			<div className="collaborators-list__body">
				<CollaboratorItem
					key={selectedContactsGroup.id + collaborator.id}
					id={collaborator.id}
					groupId={collaborator.groupId}
					index={collaborator.index}
					avatar={`${APP_URL}/account/avatar/${collaborator.id}`}
					name={collaborator.name}
					email={collaborator.email}
					statuses={collaborator.statuses}
					syncopt={collaborator.addToContact}
					permission={collaborator.permission}
					type={collaborator.type}
					mode={'selectedCollaboratorsGroup'}
				/>
			</div>
		</div>
	)
}

export default CollaboratorDetails;
